import React from "react"

import Link from "../../utils/link"

import Review from "./Review"

import "./ReviewSection.scss"

const ReviewSection = (props) => {
  return (
    <div className="review-section">
      { props.acf.reviews && props.acf.reviews.map((item, index) => {
        return (
          <div key={index}>
            <div className="review-section__one">
              <Review {...item} />
            </div>
            <div className="divider" />
          </div>
        )
      })}
    </div>
  )
}

export default ReviewSection
